import { c as _c } from "react/compiler-runtime";
import { readFragment } from "@opensea/graphql";
import { ReceiptTotalDisplay } from "../../../../components/Receipt";
import { findActiveDropStage } from "../utils";
import { MintTableRowDropFragment } from "./MintTableRow.fragment";
export const MintTableTotal = t0 => {
  const $ = _c(12);
  const {
    drop,
    tokenInputs
  } = t0;
  let price;
  let t1;
  if ($[0] !== drop || $[1] !== tokenInputs) {
    t1 = Symbol.for("react.early_return_sentinel");
    bb0: {
      const dropData = readFragment(MintTableRowDropFragment, drop);
      const activeStage = findActiveDropStage(dropData);
      price = activeStage.eligiblePrice ?? activeStage.price;
      if (dropData.__typename === "Erc1155SeaDropV2") {
        let totalUnit = 0;
        let totalUsd = 0;
        const symbol = price?.token.symbol || "ETH";
        tokenInputs.forEach(tokenInput => {
          const stageTokenData = activeStage.tokenIdMapping?.get(tokenInput.tokenId);
          const tokenPrice = stageTokenData?.price;
          if (tokenPrice) {
            totalUnit = totalUnit + tokenPrice.token.unit * tokenInput.quantity;
            totalUnit;
            totalUsd = totalUsd + tokenPrice.usd * tokenInput.quantity;
            totalUsd;
          }
        });
        const t2 = totalUnit;
        const t3 = totalUsd;
        let t4;
        if ($[4] !== symbol || $[5] !== t2 || $[6] !== t3) {
          t4 = <ReceiptTotalDisplay prices={[{
            unit: t2,
            symbol,
            usd: t3
          }]} />;
          $[4] = symbol;
          $[5] = t2;
          $[6] = t3;
          $[7] = t4;
        } else {
          t4 = $[7];
        }
        t1 = t4;
        break bb0;
      }
    }
    $[0] = drop;
    $[1] = tokenInputs;
    $[2] = price;
    $[3] = t1;
  } else {
    price = $[2];
    t1 = $[3];
  }
  if (t1 !== Symbol.for("react.early_return_sentinel")) {
    return t1;
  }
  const totalQuantity = tokenInputs.reduce(_temp, 0);
  const totalUnit_0 = (price?.token.unit || 0) * totalQuantity;
  const totalUsd_0 = (price?.usd || 0) * totalQuantity;
  const t2 = price?.token.symbol || "ETH";
  let t3;
  if ($[8] !== t2 || $[9] !== totalUnit_0 || $[10] !== totalUsd_0) {
    t3 = <ReceiptTotalDisplay prices={[{
      unit: totalUnit_0,
      symbol: t2,
      usd: totalUsd_0
    }]} />;
    $[8] = t2;
    $[9] = totalUnit_0;
    $[10] = totalUsd_0;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  return t3;
};
function _temp(sum, item) {
  return sum + item.quantity;
}